import React, { useEffect, useRef, useState } from 'react';
import './Datasets.css'; // We'll update this CSS

// Import your new images - replace with actual paths
// import distributionImage1 from './structures_per_target.png'; // Removed
// import distributionImage2 from './dist_pocket_sim.png'; // Removed

import physicsIcon from './icons/physics.png';
import physicsIconOn from './icons/physics_on.png';
import aiDockingIcon from './icons/ai_docking.png';
import aiDockingIconOn from './icons/ai_docking_on.png';
import cofoldingIcon from './icons/cofolding.png';
import cofoldingIconOn from './icons/cofolding_on.png';

const DatasetsHighlight = () => {
  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const idx = Number(entry.target.getAttribute('data-card-index'));
          setVisibleCards((prev) => ({ ...prev, [idx]: entry.isIntersecting }));
        });
      },
      {
        threshold: 0.28,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    cardRefs.current.forEach((card) => {
      if (card) {
        observer.observe(card);
      }
    });

    return () => observer.disconnect();
  }, []);

  const coverageCards = [
    {
      title: 'Physics-based',
      icon: physicsIcon,
      iconOn: physicsIconOn,
      lines: ['Discovery Studio / Schrödinger Glide', 'MOE / AutoDock Vina / GNINA'],
    },
    {
      title: 'AI docking',
      icon: aiDockingIcon,
      iconOn: aiDockingIconOn,
      lines: ['DeepDock / EquiBind / TankBind', 'DiffDock family / Uni-Mol Docking V2', 'FABind / DynamicBind / HelixDock / SurfDock'],
    },
    {
      title: 'AI co-folding',
      icon: cofoldingIcon,
      iconOn: cofoldingIconOn,
      lines: ['NeuralPLexer / RFAA / AlphaFold 3', 'Chai-1 / Boltz-1 / Boltz-1x', 'Protenix'],
    },
  ];

  return (
    <div className="outer_container">
    <div className="datasets-main-container">
      {/* <h1 className="datasets-main-title">Our Datasets: PoseX-SD & PoseX-CD</h1> */}

      {/* --- Section 1 & 2 Removed --- */}

      <section className="dataset-subsection coverage-section">
        <div className="coverage-header">
          <div className="coverage-title-wrap">
            <div className="coverage-title">Full coverage (23 methods)</div>
          </div>
        </div>

        <div className="coverage-grid" role="list">
          {coverageCards.map((card, idx) => (
            <div
              key={card.title}
              ref={(el) => {
                cardRefs.current[idx] = el;
              }}
              data-card-index={idx}
              className={`coverage-card ${card.featured ? 'is-featured' : ''} ${visibleCards[idx] ? 'is-visible' : ''}`}
              style={{ '--float-delay': `${idx * 90}ms` }}
              role="listitem"
              tabIndex={0}
            >
              <div className="coverage-card-inner">
                <div className="coverage-icon-wrap" aria-hidden="true">
                  <img className="coverage-icon is-default" src={card.icon} alt="" />
                  <img className="coverage-icon is-on" src={card.iconOn} alt="" />
                </div>

                <div className="coverage-card-title">{card.title}</div>
                <div className="coverage-card-lines">
                  {card.lines.map((t) => (
                    <div key={t} className="coverage-card-line">
                      {t}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
    </div>
  );
};

export default DatasetsHighlight;
// import React from 'react';
// import './Datasets.css'; // We'll update this CSS

// // Import your new images - replace with actual paths
// import distributionImage1 from './structures_per_target.png'; // Placeholder
// import distributionImage2 from './dist_pocket_sim.png'; // Placeholder
// import posebustersComparisonImage from './cmp.png'; // Placeholder

// const DatasetsHighlight = () => {
//   return (
//     <div className="outer_container">
//     <div className="datasets-main-container"> {/* Changed class for overall section */}
//       <h1 className="datasets-main-title">Our Datasets: PoseX-SD & PoseX-CD</h1>

//       {/* --- Sub-section 1: Data Overview & Volume (Text Only) --- */}
//       <section className="dataset-subsection text-overview-section">
//         <h2 className="dataset-subsection-title">Dataset Composition and Scale</h2>
//         <div className="text-content-container">
//           <p>
//           We curate a high-quality protein-ligand complex structure dataset designed to evaluate molecular docking methods named PoseX. 
//           It consists of carefully selected crystal structures from the RCSB Protein Data Bank, 
//           with two subsets for assessing self-docking and cross-docking tasks. 
//           The dataset only includes complexes published from 2022 January 1st to 2025 January 1st, 
//           ensuring that there is no overlap with the training data of all AI methods that are being evaluated.
//           Additionally, it provides annotations of pocket similarity, measured by TM-Score, compared to pockets released before 2022,
//           facilitating the evaluation of model generalization based on pocket similarity.             
//           Ultimately, the dataset contains 718 entries for the self-docking set and 1,312 docking tasks for the cross-docking set, comprising 109 protein targets
//            (a total of 371 structures), and 362 small molecules. 
//           We find that each target protein has at least two conformations, and around half of the target proteins have two conformations.
//           </p>
//         </div>
//       </section>

//       {/* --- Sub-section 2: Data Distribution (Two Images Side-by-Side) --- */}
//       <section className="dataset-subsection image-showcase-section">
//         <h2 className="dataset-subsection-title">Data Distribution</h2>
//         <div className="image-row-container">
//           <div className="image-container">
//             <img
//               src={distributionImage1}
//               alt="Data Distribution Chart 1 "
//               className="showcase-image"
//             />
            
//           </div>
//           <div className="image-container">
//             <img
//               src={distributionImage2}
//               alt="Data Distribution Chart 2"
//               className="showcase-image"
//             />
            
//           </div>
//         </div>
//       </section>

//       {/* --- Sub-section 3: Comparison with PoseBusters (One Image) --- */}
//       <section className="dataset-subsection image-showcase-section">
//         <h2 className="dataset-subsection-title">Comparative Analysis: PoseX vs. PoseBusters</h2>
//         <div className="single-image-container">
//           <img
//             src={posebustersComparisonImage}
//             alt="Comparison Chart: PoseX vs. PoseBusters"
//             className="showcase-image-single" /* Potentially different styling for a single, wider image */
//           />
//         </div>
//       </section>
//     </div>
//     </div>
//   );
// };

// export default DatasetsHighlight;